import { useEffect, useState } from "react";
import { Dispatch, SetStateAction } from "react";
import TextField from "@mui/material/TextField";
import CloseIcon from "@mui/icons-material/Close";
import { Modal, Button } from "@mui/material";
import { showError } from "../constants/toasts";
import { isValidInput } from "../utils/validations";

interface ModalProps {
  open: boolean;
  onClose: () => void;
  setOpen: Dispatch<SetStateAction<boolean>>;
  isEdit?: boolean;
  initial?: { _id?: string; question?: string; answer?: string } | null;
  onSubmit: (payload: {
    question: string;
    answer: string;
    id?: string;
  }) => Promise<void> | void;
}

export default function AddFaq({
  open,
  onClose,
  setOpen,
  isEdit,
  initial,
  onSubmit,
}: ModalProps) {
  const [question, setQuestion] = useState("");
  const [answer, setAnswer] = useState("");
  const [error, setError] = useState(false);

  useEffect(() => {
    if (open) {
      setQuestion(initial?.question || "");
      setAnswer(initial?.answer || "");
    }
  }, [open, initial]);
  return (
    <Modal
      className="modal addNotification_modal"
      open={open}
      onClose={() => {
        onClose();
        setError(false);
      }}
    >
      <div className="modal-dialog">
        <div className="modal-body">
          <div className="modal_title">
            <h2>{isEdit ? "Edit FAQ" : "Add FAQ"}</h2>
            <button
              type="button"
              className="btn-close"
              onClick={() => setOpen(false)}
            >
              <CloseIcon />
            </button>
          </div>
          <form className="form" action="">
            <div className="control_group">
              <TextField
                placeholder="Question"
                fullWidth
                value={question}
                onChange={(e) => {
                  const value = e.target.value;
                  if (isValidInput(value) && value.length <= 100) {
                    setQuestion(e.target.value);
                  }
                }}
                hiddenLabel
              />
              {error && question == "" ? (
                <h6 className="err_msg">Question is required</h6>
              ) : (
                ""
              )}
            </div>
            <div className="control_group">
              <TextField
                placeholder="Answer"
                fullWidth
                hiddenLabel
                multiline
                value={answer}
                onChange={(e) => {
                  const value = e.target.value;
                  if (isValidInput(value) && value.length <= 500) {
                    setAnswer(e.target.value);
                  }
                }}
                maxRows={5}
                minRows={5}
              />
              {error && answer == "" ? (
                <h6 className="err_msg">Answer is required</h6>
              ) : (
                ""
              )}
            </div>
            <div className="footer_btn_flex">
              <Button
                className="btn btn_grey"
                onClick={() => {
                  setError(false);
                  setOpen(false);
                }}
              >
                Cancel
              </Button>
              <Button
                className="btn btn_primary"
                onClick={async () => {
                  setError(true);
                  if (question.trim() === "") {
                    // showError("Question is required");
                    return;
                  }
                  if (answer.trim() === "") {
                    // showError("Answer is required");
                    return;
                  }
                  try {
                    await onSubmit({
                      question: question.trim(),
                      answer: answer.trim(),
                      id: initial?._id,
                    });
                    setAnswer("");
                    setQuestion("");
                    setError(false);
                    setOpen(false);
                  } catch (e) {
                    // onSubmit should handle errors/toasts
                  }
                }}
              >
                Submit
              </Button>
            </div>
          </form>
        </div>
      </div>
    </Modal>
  );
}
